import {
  DETAILS_SCREENS_CONTAINER_STYLES_FOR_SCROLL_VIEW,
  IMAGES_PANEL_VIEW_MODE_WIDTH,
  NOT_PANEL_VIEW_MODE_WIDTH,
  PANEL_VIEW_MODE_WIDTH,
} from '../../../../../../common/constants/base.constants';
import { fullWidth } from '@components/frame';
import { isPhone } from '@helpers';
import { useHandleMainDetailsScreenNavigation } from '@v2/pages/common/hooks/useHandleMainDetailsScreenNavigation';
import { JobDetailsScreenName } from '@v2/pages/job/navigation/config';
import { JobDetailsScreen } from '@v2/pages/job/common/enums/jobDetails.enum';
import { LevelSubScreen, Perspective } from '@v2/pages/common/enums';
import { useNavigationCheck } from '@v2/pages/machines/hooks/useNavigationCheck';
import { SingleJobOrListProps } from '@v2/pages/machines/modules/now/components/Job/components/SingleJobOrList';

export interface UseManageSingleJobOrListParams extends Pick<SingleJobOrListProps, 'jobs' | 'jobId' | 'displaySingleJob' | 'displayImagesColumn'> {}

export const useManageSingleJobOrList = ({
  jobs,
  jobId,
  displaySingleJob,
  displayImagesColumn = true,
}: UseManageSingleJobOrListParams) => {
  const existedJobs = jobs.length === 1 && jobs[0] === null ? [] : jobs;
  const shouldDisplaySingleJob = displaySingleJob || existedJobs.filter(Boolean).length === 1;

  const { safeIsDetailsScreen: isDetailsScreen, safeIsMachinesScreenCheck: isMachinesScreen } = useNavigationCheck();
  const { navigateToMainDetailsScreen } = useHandleMainDetailsScreenNavigation();

  const shouldDisplayImagesColumn = existedJobs && !isPhone && shouldDisplaySingleJob && !isMachinesScreen && displayImagesColumn;

  const containerStyles = isMachinesScreen ? {} : DETAILS_SCREENS_CONTAINER_STYLES_FOR_SCROLL_VIEW;

  const onJobImageClick = (selectedImageKey: string) => {
    navigateToMainDetailsScreen({
      mainScreen: JobDetailsScreenName,
      subScreen: JobDetailsScreen.JOBS,
      levelSubScreen: LevelSubScreen.DOCUMENTS,
      params: {
        perspective: Perspective.JOBS,
        productionOperationId: jobId,
        selectedImageKey,
      },
    });
  };

  return {
    existedJobs,
    shouldDisplaySingleJob,
    isDetailsScreen,
    isMachinesScreen,
    shouldDisplayImagesColumn,
    containerStyles,
    onJobImageClick,
  };
};
